module.exports = __webpack_public_path__ + "dash_20_app_assets/img/collaborators.0c5761cd.png";